// Comptes utilisateurs : persistés côté serveur (mots de passe hachés bcrypt).
// Aucun mot de passe ne transite ni ne reste dans le navigateur.
import { modulesParDefaut, ROLES } from './permissions';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

const json = async (r) => {
  const data = await r.json().catch(() => null);
  if (!r.ok) return { error: String(data?.detail ?? `Erreur ${r.status}`), row: null };
  return { error: null, row: data };
};

const versFront = (u) => ({
  email: u.email,
  name: u.nom ?? u.name ?? u.email,
  role: u.role,
  modules: u.modules === '*' ? modulesParDefaut(ROLES.ADMIN) : (u.modules ?? []),
  actif: u.actif !== false,
  permissions_personnalisees: u.permissions_personnalisees === true,
  peut_deroger_minimum: u.peut_deroger_minimum === true,
});

const versServeur = ({ email, name, password, role, modules, actif, permissions_personnalisees, peut_deroger_minimum }) => ({
  email: String(email || '').trim().toLowerCase(),
  nom: (name || '').trim(),
  role,
  modules: modules ?? null,
  permissions_personnalisees: permissions_personnalisees === true,
  peut_deroger_minimum: peut_deroger_minimum === true,
  actif: actif !== false,
  ...(password ? { mot_de_passe: password } : {}),
});

export async function fetchUtilisateurs() {
  const r = await fetch(`${API}/utilisateurs`);
  if (!r.ok) return [];
  return (await r.json()).map(versFront);
}

export async function creerUtilisateur(fiche) {
  const { error, row } = await json(
    await fetch(`${API}/utilisateurs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(versServeur(fiche)),
    })
  );
  return { error, row: row ? versFront(row) : null };
}

export async function majUtilisateur(fiche) {
  const { error, row } = await json(
    await fetch(`${API}/utilisateurs/${encodeURIComponent(fiche.email)}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(versServeur(fiche)),
    })
  );
  return { error, row: row ? versFront(row) : null };
}

export async function supprimerUtilisateur(email) {
  const { error } = await json(
    await fetch(`${API}/utilisateurs/${encodeURIComponent(email)}`, { method: 'DELETE' })
  );
  return { error };
}

// Confirmation d'une action sensible : le mot de passe est vérifié PAR LE SERVEUR.
export async function verifierMotDePasse(motDePasse) {
  const r = await fetch(`${API}/verifier`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mot_de_passe: motDePasse }),
  });
  return r.ok;
}

export async function changerMonMotDePasse(actuel, nouveau) {
  return json(
    await fetch(`${API}/moi/mot-de-passe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ actuel, nouveau }),
    })
  );
}
